/** @module Enums */ /** typedoc */
var ReleaseGlobalStateEnum;
(function (ReleaseGlobalStateEnum) {
    ReleaseGlobalStateEnum["Released"] = "Released";
    ReleaseGlobalStateEnum["Draft"] = "Draft";
    ReleaseGlobalStateEnum["InProgress"] = "InProgress";
    ReleaseGlobalStateEnum["TakenDown"] = "TakenDown";
    ReleaseGlobalStateEnum["Paused"] = "Paused";
})(ReleaseGlobalStateEnum || (ReleaseGlobalStateEnum = {}));

export { ReleaseGlobalStateEnum };
